@if (formGroup && control && formControlName) {
<div>
    @if (header) {
    <h3 [id]="headerId">{{ header }}</h3>
    } @if (label) {
    <h4 [id]="labelId">{{ label }}{{ required ? " *" : "" }}</h4>
    }
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
        <div
            fxFlex="100"
            fxLayoutAlign="start center"
            fxFlex.xs="100"
            fxFlexFill
        >
            <span
                class="radio-checkbox-group"
                fxFlex="100"
                role="group"
                [attr.aria-labelledby]="activeHeadingId"
            >
                <ul role="presentation">
                    @for (selection of selections; track selection) {
                    <li>
                        @if (control) {
                        <mat-checkbox
                            [value]="selection.selectionId.toString()"
                            [checked]="_value.includes(selection.selectionId)"
                            color="primary"
                            (change)="updateCheckboxGroup($event)"
                        >
                            <span class="wrap-mat-radio-checkbox-label">{{
                                selection.label
                            }}</span>
                        </mat-checkbox>
                        }
                    </li>
                    }
                </ul>
                @if ( ((control && control.touched) || formSubmitted) &&
                hasRequiredError ) {
                <mat-error>{{ requiredMessage }} </mat-error>
                }
            </span>
        </div>
    </div>
</div>
}
